import { dimensions } from '@/mocks/dimensions';

const toneMap: Record<string, { chip: string; dot: string }> = {
  details: { chip: 'bg-primary-50 text-primary-700 border-primary-200', dot: 'bg-primary-500' },
  foreshadow: { chip: 'bg-accent-50 text-accent-800 border-accent-200', dot: 'bg-accent-500' },
  timeline: { chip: 'bg-secondary-50 text-secondary-800 border-secondary-200', dot: 'bg-secondary-500' },
  connections: { chip: 'bg-foreground-100 text-foreground-800 border-background-300', dot: 'bg-foreground-700' },
};

export default function DimensionTag({ id, withDot = true }: { id: string; withDot?: boolean }) {
  const dimension = dimensions.find((item) => item.id === id);
  const tone = toneMap[id] ?? toneMap.details;

  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 font-label text-xs ${tone.chip}`}
    >
      {withDot && <span className={`h-1.5 w-1.5 rounded-full ${tone.dot}`} />}
      {dimension ? dimension.name : '拆解'}
    </span>
  );
}